import React from 'react';
import { targetIndustries } from '../data/mock';
import { Building2, Home, TrendingUp, Briefcase } from 'lucide-react';

const iconMap = {
  'Hypothekarberater': Home,
  'Treuhandunternehmen': Briefcase,
  'Finanzdienstleister': TrendingUp,
  'Immobilienunternehmen': Building2
};

const customerLogos = [
  {
    name: 'Immano AG',
    tagline: 'Ihre Hypothek - unsere Priorität',
    logo: '/images/immano-logo.png'
  },
  // Placeholder für weitere Logos
  { name: 'Kunde 2', logo: null },
  { name: 'Kunde 3', logo: null },
  { name: 'Kunde 4', logo: null },
  { name: 'Kunde 5', logo: null },
  { name: 'Kunde 6', logo: null }
];

const Customers = () => {
  return (
    <section id="customers" className="customers-section">
      <div className="section-container">
        <h2 className="section-title">Unsere Kunden</h2>
        
        <p className="customers-intro">
          Vertrauen von führenden Unternehmen in verschiedenen Branchen
        </p>

        <div className="customers-industries">
          {targetIndustries.map((industry, index) => {
            const Icon = iconMap[industry];
            return (
              <div key={index} className="industry-card">
                <div className="industry-icon">
                  <Icon size={32} />
                </div>
                <h3 className="industry-name">{industry}</h3>
              </div>
            );
          })}
        </div>

        <div className="customers-logos-section">
          <h3 className="logos-section-title">Vertrauen uns bereits</h3>
          
          <div className="logo-carousel">
            <div className="logo-carousel-track">
              {/* Duplicate logos for infinite scroll effect */}
              {[...customerLogos, ...customerLogos].map((customer, index) => (
                <div key={index} className="logo-carousel-item">
                  {customer.logo ? (
                    <div className="logo-card">
                      <img 
                        src={customer.logo} 
                        alt={customer.name}
                        className="customer-logo"
                      />
                      {customer.tagline && (
                        <p className="logo-tagline">{customer.tagline}</p>
                      )}
                    </div>
                  ) : (
                    <div className="logo-placeholder">
                      <span>{customer.name}</span>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Customers;
